import cn from 'classnames'
import type { ReactNode } from 'react'

import { PLAN_REVIEW_JUSTIFICATION_PROMPT } from '../../config/justification'

import { JustificationAction } from './JustificationAction'

import styles from './JustificationBanner.module.scss'

interface IJustificationBannerProps {
  justification?: string
  canEdit: boolean
  onClick: () => void
  message?: ReactNode
  messageClassName?: string
}

export const JustificationBanner = ({
  justification,
  canEdit,
  onClick,
  message,
  messageClassName,
}: IJustificationBannerProps) => (
  <div className={styles.banner}>
    <span className={cn(styles.message, messageClassName)}>
      {message ?? PLAN_REVIEW_JUSTIFICATION_PROMPT}
    </span>
    <JustificationAction justification={justification} canEdit={canEdit} onClick={onClick} />
  </div>
)
